import { AnyAction } from 'redux'
import type { State } from 'shared/types/gallery/state'

const INITIAL_STATE: State.DesignPersonalizationState = {
  designPersonalizationContext: undefined,
  designPersonalizationContextId: undefined,
  dpcsLoading: false,
}

export const DESIGN_PERSONALIZATION_CONTEXT_UPDATE = 'DESIGN_PERSONALIZATION_CONTEXT_UPDATE'
export const DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE = 'DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE'

export const DPCS_LOADING_UPDATE = 'DPCS_LOADING_UPDATE'
export const NEW_MODULE_HAS_IMAGE_UPDATE = 'NEW_MODULE_HAS_IMAGE_UPDATE'
export const NEW_MODULE_HAS_COLOR_UPDATE = 'NEW_MODULE_HAS_COLOR_UPDATE'
export const COLOR_VARIATION_DPCS_UPDATE = 'COLOR_VARIATION_DPCS_UPDATE'

export function reducer(state: State.DesignPersonalizationState = INITIAL_STATE, action: AnyAction): State.DesignPersonalizationState {
  switch (action.type) {
    case DESIGN_PERSONALIZATION_CONTEXT_UPDATE: {
      return {
        ...state,
        designPersonalizationContext: action.payload.dpc,
      }
    }
    case DESIGN_PERSONALIZATION_CONTEXT_ID_UPDATE: {
      return {
        ...state,
        designPersonalizationContextId: action.payload.id,
      }
    }
    case DPCS_LOADING_UPDATE: {
      return {
        ...state,
        dpcsLoading: action.payload.dpcsLoading,
      }
    }
    case NEW_MODULE_HAS_IMAGE_UPDATE: {
      return {
        ...state,
        designPersonalizationWidgetHasImage: action.payload.designPersonalizationWidgetHasImage,
      }
    }
    case NEW_MODULE_HAS_COLOR_UPDATE: {
      return {
        ...state,
        designPersonalizationWidgetHasColor: action.payload.designPersonalizationWidgetHasColor,
      }
    }
    case COLOR_VARIATION_DPCS_UPDATE: {
      return {
        ...state,
        colorVariationDPCs: action.payload.colorVariationDPCs,
      }
    }
    default:
      return state
  }
}
